import { getServerTagList } from '@/assets/api/serviceManagement'
import { flattenArrayObject } from '@/utils/flattenArrayObject'
const globalData = {
  state: {
    // 服务管理，服务类型枚举值
    serverManageTypeList: [],
    // 推荐专家
    serverExpertList: [],
  },
  mutations: {
    // 设置服务管理，服务类型枚举值
    setServerManageTypeList(state, config) {
      state.serverManageTypeList = config
    },
    // 设置服推荐专家
    setServerExpertList(state, config) {
      state.serverExpertList = config
    },
  },
  getters: {
    // 获取服务管理，服务类型枚举值
    getServerManageTypeList(state) {
      return flattenArrayObject(state.serverManageTypeList, 'children')
    },
    // 获取推荐专家
    getServerExpertList(state) {
      return flattenArrayObject(state.serverExpertList, 'list')
    },
  },
  actions: {
  getServerManageTypeListAction({ commit }) {
      getServerTagList({}).then((res) => {
        commit('setServerManageTypeList', res.data)
      })
    },
  },
}
export default globalData
